<template>
    <b-button class="text-left max-content"
              variant="light"
              @click="$emit('btnClick')">
        <b-badge v-if="selected"
                 variant="warning">
            <i class="fa-solid fa-caret-left"></i>
        </b-badge>
        {{ entity.target }}
    </b-button>
</template>

<script>
export default {
    name: "EntityBtn",
    props: {
        entity: Object,
        selected: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style scoped>
.max-content {
    width: max-content !important;
}
</style>
